__turbopack_context__.v({
  "parallax": "Footer-module__VT35Wa__parallax",
  "root": "Footer-module__VT35Wa__root",
  "wave1": "Footer-module__VT35Wa__wave1",
  "wave2": "Footer-module__VT35Wa__wave2",
  "wave3": "Footer-module__VT35Wa__wave3",
  "wave4": "Footer-module__VT35Wa__wave4",
  "waves": "Footer-module__VT35Wa__waves",
  "waving": "Footer-module__VT35Wa__waving",
});
